module.exports = __webpack_public_path__ + "static/video-2-7fea6af4b64bd1f4c24ff06a225c4004.mp4";